import { useEffect } from "preact/hooks";
import { useDateTime } from "../utils";
import { isPastPresentFuture } from "./AgendaSidebar";

export default function SessionTracker({ agenda, onComplete = null, triggerAt = 15 }) {
    const now = useDateTime()


    useEffect(() => {
        const current = agenda.map(isPastPresentFuture("startDate", "endDate", now)).find(x => x.active)
        if (!current) return;

        const storageTitle = `wt_${current.title}_${current.room}`

		const time = (parseInt(localStorage.getItem(storageTitle)) || 0) + 1

        if(time === triggerAt) {
            onComplete?.call(null, current.title.startsWith("Keynote"))
        }

        if (time > triggerAt) return;

        localStorage.setItem(storageTitle, time)
    }, [now])
    return <></>
}